'use strict';

/**
 * Layout view
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Cengiz Mardin <cm@humans.am>
 */

var LayoutView = require('base/Colido.LayoutView');
var ManageStorageList = require('../partials/manage-storage-list');

var template = require('modules/collection/modules/location/templates/layout/manage-storages-modal.hbs');

require('jquery-nestable');

var ManageStoragesModalView = LayoutView.extend({
    template: template,

    regions: {
        storagesListRegion: '.storages-list',
        storagesListNestedRegion: '.storages-list .dd-list-nestable',
        storagesTrashRegion: '.storages-trash',
    },

    ui: {
        actionClose: '[data-action="close"]',
        actionSave: '[data-action="save"]',
        actionNewStorage: '[data-action="add-new-storage"]',
        actionManagingModeArrange: '[data-action="manage-mode-arrange"]',
        actionManagingModeName: '[data-action="manage-mode-name"]',

        storagesList: '.storages-list',
        storagesTrash: '.storages-trash',
    },

    events: {
        'click @ui.actionClose': 'actionClose',
        'click @ui.actionSave': 'actionSave',
        'click @ui.actionNewStorage': 'actionNewStorage',
        'click @ui.actionManagingModeArrange': 'actionManagingModeArrange',
        'click @ui.actionManagingModeName': 'actionManagingModeName',
    },

    somethingHasChanged: false,
    newItemsId: -1,

    actionManagingModeArrange: function(event){
        this.ui.storagesList.find('.dd-list-nestable .dd-nohandle').removeClass('dd-nohandle').addClass('dd-handle');
        this.ui.actionManagingModeArrange.attr('data-checked', 'checked');
        this.ui.actionManagingModeName.attr('data-checked', '');
    },
    actionManagingModeName: function(event){
        this.ui.storagesList.find('.dd-list-nestable .dd-handle').removeClass('dd-handle').addClass('dd-nohandle');
        this.ui.actionManagingModeArrange.attr('data-checked', '');
        this.ui.actionManagingModeName.attr('data-checked', 'checked');
    },

    actionClose: function (event) {
        this.trigger('close:modal');
    },

    /**
     * UI-Event
     * Speichern und schließen, wobei beim speichern erstmals eine/mehrere anfrage(n) an die API gesendet wird/werden.
     *
     * @param event
     */
    actionSave: function(event) {
        this.ui.actionSave.prop('disabled', true).addClass('is-loading');

        if (this.somethingHasChanged) {
            this.handleSaveList();
        }

        this.trigger('close:modal');
    },

    /**
     * Erstellt ein neues Stoarge in der Liste
     * Es wird noch keine Anfrage an die API geschickt.
     *
     * @param event
     */
    actionNewStorage: function(event){
        this.ui.actionNewStorage.hide();
        var $html = $('<li class="dd-item new-item"  data-dirty="1" data-id="' + this.newItemsId + '"><div class="dd-nohandle"><input type="text" /></div></li>');
        this.newItemsId--;
        this.ui.storagesList.find('div.dd-list-nestable > ol').append($html);
        $html.find('input[type="text"]').focus();

        $html.find('input[type="text"]').keyup(function(event){
            if (event.keyCode == 13){
                $html.find('input[type="text"]').trigger('focusout');
                $html.find('input[type="text"]').blur();
                $(this).off(event);
            }
        });

        $html.find('input[type="text"]').one('focusout', function(){
            $html.removeClass('new-item').find('.dd-nohandle').removeClass('dd-nohandle').addClass('dd-handle');
            this.ui.actionNewStorage.show();
        }.bind(this));
    },

    onShow: function () {
        var filteredCollection = this.collection.getFilteredCollection(function(model) {
            return model.get('isRoot'); //  || model.get('parent') === 0 || model.get('parent') === 1
        });

        this.storagesListNestedRegion.show(new ManageStorageList({
            collection: filteredCollection,
        }));

        this.ui.storagesList.find('div.dd-list-nestable').nestable({
            group: 1,
            maxDepth: 5,
        });

        this.ui.storagesTrash.find('div.dd-list-nestable').nestable({
            group: 1,
            maxDepth: 5,
        });

        // insert empty-box for trash
        this.ui.storagesTrash.find('div.dd-list-nestable').html('<div class="dd-empty"></div>');

        // call stuff on changeing the listelements name and/or order
        this.ui.storagesList.find('div.dd-list-nestable').on('change', function () {
            this.somethingChanged();
        }.bind(this));

        this.ui.storagesTrash.find('div.dd-list-nestable').on('change', function () {
            this.somethingChanged();
        }.bind(this));

        var storageCount = this.ui.storagesList.find('li').length;
        this.$('header .subline.object-count').html(App.t('collection::locations:manage-storages:object-count', storageCount));
    },

    /**
     * Wird aufgerufen, sobald sich etwas an der Liste verändert hat und indikiert damit, dass
     * beim speichern und schließen eine anfrage an den server gesendet werden muss.
     * Außerdem sorgt es dafür, dass der Trash flat bleibt.
     */
    somethingChanged: function(){
        this.somethingHasChanged = true;
        this.ui.actionSave.prop('disabled', false);
        var storageCount = this.ui.storagesList.find('li').length;
        this.$('header .subline.object-count').html(App.t('collection::locations:manage-storages:object-count', storageCount));
    },

    /**
     * Arbeitet den ersten Schritt ab, die Liste zu speichern, wobei zunächst nur die neuen Items
     * gesetzt werden und die zu löschen gelöscht werden. Nach erfolgreichem hinzufügen aller neuen elemente
     * werden die hirachien gesetzt. Das muss so sein, da man sonst kein Item unter einem neuen Item
     * setzten könnte -> henne-ei-problem.
     */
    handleSaveList: function(){
        var serializedFlatData = this.ui.storagesList.find('div.dd-list-nestable').nestable('serializeFlat');
        var serializedFlatDataTrash = this.ui.storagesTrash.find('div.dd-list-nestable').nestable('serializeFlat');

        var newItems = [];

        var toWaitItems = 0;

        // find the new items
        _.each(serializedFlatData, function(obj){
            if (obj.id < 0){
                var data = {
                    //parent: obj.parent, to parents @ continueHandleSaveList
                    name: obj.name,
                    parent: 0,
                };

                toWaitItems++;

                var model = new this.collection.model(null, {collection: this.collection});
                model.save(data, {
                    success: function(o) {
                        toWaitItems--;

                        if (toWaitItems == 0){
                            this.continueHandleSaveList(newItems, serializedFlatData);
                        }
                    }.bind(this),
                    error: function(data){
                        this.showSimpleError();
                    }.bind(this),
                });
                newItems.push({tmpId: obj.id, obj: model});
            }
        }.bind(this));

        // find items for the trash
        _.each(serializedFlatDataTrash, function(obj){
            if (obj.id > 0){
                var model = this.collection.get(obj.id);
                model.destroy({
                    error: function(data){
                        this.showSimpleError();
                    }.bind(this),
                });
                this.collection.remove(model);
            } else {
                // nothing to do here, it was a new one, wich was not created yet
            }
        }.bind(this));

        if (newItems.length < 1){
            // no new items -> dont wait, do it immediately.
            this.continueHandleSaveList([], serializedFlatData);
        }
    },

    /**
     * Führt das Hinzufügen fort. Setzt die ID der neuen Items korrekt und setzt anschließend die neuen
     * Hierarchien, sowie dessen Bezeichner.
     *
     * @param newItems
     */
    continueHandleSaveList: function(newItems, serializedFlatData){
        // var serializedFlatData = this.ui.storagesList.find('div.dd-list-nestable').nestable('serializeFlat');

        var idMappping = {};

        // setzte die ID richtig
        _.each(serializedFlatData, function(obj, index){
            if (obj.id < 0){
                _.each(newItems, function(item){
                    if (item.tmpId === obj.id){
                        serializedFlatData[index].id = item.obj.get('id');
                        idMappping[item.tmpId] = serializedFlatData[index].id;
                    }
                }.bind(this));
            }
        }.bind(this));

        _.each(serializedFlatData, function(obj){
            //if (obj.dirty === 1){ // would not update the order on every object, but its important to do so
            // -> set the sort-partner also dirty, and than comment this comment of

            //correct the list serializedFlatData by the given parent-id's
            if (obj.parent < 0){
                obj.parent = idMappping[obj.parent];
            }

            if (obj.parent === 0 || obj.parent === null) {
                obj.isRoot = 1;
            } else {
                obj.isRoot = 0;
            }

            var data = {
                parent: obj.parent,
                name: obj.name,
                isRoot: obj.isRoot,
                sortOrder: obj.sort,
            };

            var model = this.collection.get(obj.id);
            model.set(data);
            //}
        }.bind(this));

        this.collection.save({
            error: function(data){
                this.showSimpleError();
            }.bind(this),
        });
    },

    showSimpleError: function() {
        Messenger().error({
            message: App.t('collection::locations:manage-storages:simple-error'),
        });
    },
});

module.exports = ManageStoragesModalView;